/**
 * 基础配置 - 应用配置 接口定义（标签、规则等）
 */
import { DEFAULT_PAGE_SIZE } from '@/constants/api';
import { apiGet, apiPost, apiPut, apiRequest } from '@/utils/request';
import { parsePaginatedResponseFull } from '@/utils/apiResponse';

export const appConfigTagsApi = {
  list: (params: Record<string, unknown> = {}) =>
    apiGet('/app-config/tags', { page: 1, per_page: DEFAULT_PAGE_SIZE, ...params }).then((d) =>
      parsePaginatedResponseFull(d),
    ),
  create: (data: Record<string, unknown>) => apiPost('/app-config/tags', data),
  update: (id: number, data: Record<string, unknown>) => apiPut(`/app-config/tags/${id}`, data),
  delete: (id: number) => apiRequest(`/app-config/tags/${id}`, { method: 'DELETE' }),
};

/**
 * 标签远程分页选项（供条件构建器 RemoteSelect 使用）
 * 触发条件不区分标签类型，系统标签与自定义标签均可作为条件被选择
 */
export async function fetchTagOptions(params: {
  page: number;
  pageSize: number;
  keyword: string;
  ids?: (string | number)[];
}): Promise<{ list: Record<string, any>[]; total: number }> {
  const hasIds = !!(params.ids && params.ids.length > 0);
  const res = await appConfigTagsApi.list({
    page: params.page,
    per_page: params.pageSize,
    name: params.keyword || undefined,
    ids: hasIds ? params.ids!.join(',') : undefined,
    status: 1,
  });
  return { list: res.list as Record<string, any>[], total: res.total };
}

export const appConfigRulesApi = {
  list: (params: Record<string, unknown> = {}) =>
    apiGet('/app-config/rules', { page: 1, per_page: DEFAULT_PAGE_SIZE, ...params }).then((d) =>
      parsePaginatedResponseFull(d),
    ),
  create: (data: Record<string, unknown>) => apiPost('/app-config/rules', data),
  update: (id: number, data: Record<string, unknown>) => apiPut(`/app-config/rules/${id}`, data),
  delete: (id: number) => apiRequest(`/app-config/rules/${id}`, { method: 'DELETE' }),
};
